import { ALERT_CHANNELS_OPTIONS_PRO } from '@/config/dict';

export default {
  AlertChannels: ALERT_CHANNELS_OPTIONS_PRO,
  alertReceiverKey: 'alertReceiversName',
};
